<app-header [pageName]="pageName"></app-header>

<div class="page-header header-color">
    <div class="container">

        <div class="row">

            <div class="col-md-6">
                <h1 class="title">Sponsorship Applications</h1>
                <p class="subtitle">Sponsorship Request list page where Sponsors can view and manage all
                    sponsorship application requests</p>
            </div>

            <div class="col-md-6 d-flex justify-content-center">
                <img class="logo" src="../../assets/images/logo_white.png" alt="">
            </div>

        </div>

    </div>
</div>

<div class="container-fluid mt-negative" *ngIf="!displayDetails">

    <div class="row">

        <div id="sidebar" class="col-md-2 type_div">
            <div class="row ">
                <div class="card sidebar-card">
                    <p class="ml"><b>Filter Valuations</b></p>
                    <div class="form-check" *ngFor="let category of categories">
                        <input class="form-check-input" [(ngModel)]="category.isSelected"
                            type="checkbox" value={{category.value}} id="defaultCheck1">
                        <label class="form-check-label" for="defaultCheck1">
                            {{category.value}}
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div id="body-container" class="col">

            <div>
                <div class="row card_div">
                    <!-- <div class="col-sm-4" *ngFor="let application of sp_application" (click)="onDisplayDetails(application)">
                        <div class="card border-light mb-4 shadow propertyCard">
                            <div class="card-body">
                                <div class="vertical-center">
                                    <div class="row"> 
                                        <div class="col-md-4 nogutters d-flex justify-content-center">
                                            <img class="event_logo rounded" src={{imageBaseUrl+application.image_url}}
                                                alt="">
                                        </div>
                                        <div class="col-md-8 nogutters">
                                            <h4 class="cardHeading">{{application.propName}} - Valuation</h4>
                                        </div>
                                    </div>
                                    <p class="text-right status">Status: {{application.status}}</p>

                                    <hr class="hr">

                                    <div class="row">
                                        <p class="cardDescription">{{application.propDescription}}</p>
                                    </div>
                                </div>
                                <img src="../../assets/images/arrow.svg" class="arrow" alt="">
                            </div>
                        </div>
                    </div> -->
                    <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort>

                        <!-- Logo Column -->
                        <ng-container matColumnDef="image_url">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                          <td mat-cell *matCellDef="let row" (click)="onDisplayDetails(row)" class="pointer"> <img
                              class="event_logo rounded" src="{{ imageBaseUrl+row.image_url}}" alt=""> </td>
                        </ng-container>
            
                        <!-- Name Column -->
                        <ng-container matColumnDef="propName">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Property Name </th>
                          <td mat-cell *matCellDef="let row" (click)="onDisplayDetails(row)" class="pointer">
                            {{row.propName}} </td>
                        </ng-container>
            
                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                          <td mat-cell *matCellDef="let row" (click)="onDisplayDetails(row)" class="pointer"> {{row.status}} </td>
                        </ng-container>
            
                        <!-- Description Column -->
                        <ng-container matColumnDef="propDescription">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Property Description </th>
                          <td mat-cell *matCellDef="let row" (click)="onDisplayDetails(row)" class="pointer">
                            {{row.propDescription}} </td>
                        </ng-container>
            
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>
                      </table>
            
                      <mat-paginator [pageSizeOptions]="[2, 5, 10, 25, 100]"></mat-paginator>
                </div>
            </div>

        </div>

    </div>

</div>

<div class="container-fluid mt-negative" *ngIf="displayDetails">
    <app-edit-sponsorship-application  [(visible)]="displayDetails" [applicationInfo]="_application">
    </app-edit-sponsorship-application>
</div>

<app-footer></app-footer>

<!-- <app-edit-sponsorship-application [(visible)]="displayDetails" [applicationInfo]="_application">
</app-edit-sponsorship-application> -->